import React, { useContext, useEffect, useState } from "react";
import { scAxiosAdmin } from "../../..";
import {
  API_TOKEN_NAME,
  IMAGE_URL,
  SITE_URL,
  USER_ID,
  USER_LOCAL_ID,
} from "../../../constants";
import icon2 from "../../../images/icon-2.png";
import { MyContext } from "../../MyProvider";
import $ from "jquery";
import PopupIndex2 from "../PopupIndex2";
import PatientRegisterPopup from "../PatientRegistrationPopup";
import BookAppointmentParticularDoctorPopUp from "../BookAppointmentParticularDoctorPopUp";
import { Link } from "react-router-dom";
import { isMobile, isTablet } from "react-device-detect";
const Department = ({ departments, doctors, handleChange }) => {
  // console.log(doctors, "doctors")
  const [departmentData, setDepartmentData] = useState([]);
  const [doctorsData, setDoctorsData] = useState([]);
  const [doctorsDetails, setDoctorsDetails] = useState([]);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [patientRegPopup, setPatientRegPopup] = useState(false);
  const [showPatientRegPopup, setShowPatientRegPopup] = useState("");
  const [showthirdpopup, setShowThirdPopup] = useState("");
  const [showDoctorSearchPopup, setShowDoctorSearchPopup] = useState(false);
  const [doctorName, setDoctorName] = useState("");
  const [filterdoctorsData, setFilterDoctorsData] = useState();
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [step, setStep] = useState(1);
  const { DoctorData } = useContext(MyContext);
  useEffect(() => {
    if (departments.length > 0) setFilterDoctorsData(departments[0].dept_id);
  }, [departments]);

  useEffect(() => {
    const getFilterDoctors = () => {
      if (filterdoctorsData) {
        const req = scAxiosAdmin.request(
          `/bodypart/getbodypartdepartmentdoctors?bodyDeptId=${filterdoctorsData}`,
          {
            method: "get",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
            },
          }
        );
        req
          .then((response) => {
            // Handle successful response here

            // console.log(response, "filterData")
            setDoctorsDetails(response.data.data);
          })
          .catch((error) => {
            // Handle error here
            console.error("Error:", error);
          });
      }

      /* .then((res) => setNewsEventData(res.data) console.log('your log output',res))
              .catch((err) => console.log("your log output", err)); */
    };
    getFilterDoctors();
  }, [filterdoctorsData]);
  useEffect(() => {
    const getAllDepartments = () => {
      const req = scAxiosAdmin.request("/department/getdepartments", {
        method: "get",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
        },
      });
      req
        .then((response) => {
          // Handle successful response here

          setDepartmentData(response.data.data);
        })
        .catch((error) => {
          // Handle error here
          console.error("Error:", error);
        });
      /* .then((res) => setNewsEventData(res.data) console.log('your log output',res))
              .catch((err) => console.log("your log output", err)); */
    };
    getAllDepartments();
  }, []);

  useEffect(() => {
    const getAllDoctors = () => {
      const req = scAxiosAdmin.request("/doctors/getalldoctors", {
        method: "get",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
        },
      });
      req
        .then((response) => {
          // Handle successful response here
          //   console.log(response,"doctors")
          setDoctorsData(response.data.data.data);
        })
        .catch((error) => {
          // Handle error here
          console.error("Error:", error);
        });
      /* .then((res) => setNewsEventData(res.data) console.log('your log output',res))
              .catch((err) => console.log("your log output", err)); */
    };
    getAllDoctors();
  }, []);
  const closePopup = () => {
    this.setState({ isPopupOpen: false });
  };
  const nextStep = (e) => {
    setStep((prev) => prev + 1);
  };
  const prevStep = (e) => {
    /* this.setState({
      step: this.state.step - 1,
      showthirdpopup: "offcanvas offcanvas-start show",
    }); */
    setStep((prev) => prev + 1);
  };

  const handlerId = (id) => {
    setFilterDoctorsData(id);
  };

  return (
    <div className="h-100">
      <div className="our-departments excellenceWrapper">
        <div className="row h-100">
          <div className="col-md-6 d-flex flex-column justify-content-between h-100 departmentWrapper">
            <div
              className={`${isMobile || isTablet ? "mt-5" : ""}`}
              style={{
                marginBottom: "10px",
              }}
            >
              <h3
                className="text-left"
                style={{
                  color: "#af9763",
                  fontSize: "28px",
                  fontWeight: "500",
                }}
              >
                Departments
              </h3>
            </div>
            <div
              className="row justify-content-start departmentsContainer"
              style={{
                // height: `${!isMobile ? "555px" : ""}${
                //   !isTablet ? "555px" : ""
                // }`,
                overflowY: "auto", // Vertical scroll remains
                overflowX: "auto", // Enable horizontal scroll
                // flexWrap: isMobile ? "nowrap" : "wrap", // Prevent wrapping for horizontal scroll
              }}
            >
              {departments.length > 0
                ? departments.map((body_department) => {
                    return (
                      <div
                        className={`${
                          departments.length > 2 ? "col-8 " : "col-12"
                        } col-md-6 pt-3 `}
                        style={{ flex: "0 0 auto" }} // Prevent wrapping and give the same width to each item
                        key={body_department.id}
                      >
                        <div
                          // className="p-3 make-orange"
                          className="p-3"
                          style={{
                            width: "100%",
                            height: "114px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "16px",

                            backgroundColor:
                              filterdoctorsData === body_department.dept_id
                                ? "#f4d69d"
                                : "#E6DFCF",
                            // color:
                            //   filterdoctorsData === body_department.dept_id
                            //     ? "#FFFFFF"
                            //     : "#000000",
                            color: "#000000",
                            cursor: "pointer",
                          }}
                          onClick={() => handlerId(body_department.dept_id)}
                        >
                          <div
                            className="row d-flex align-items-center flex-column justify-content-center"
                            name="body_dept_id"
                            value={body_department.dept_id}
                          >
                            <div className="col-12 d-flex align-items-center justify-content-center">
                              {body_department.image ? (
                                <img
                                  src={
                                    IMAGE_URL +
                                    "DepartmentImage/" +
                                    body_department.image
                                  }
                                  alt="avtars"
                                  style={{ width: "27.42px" }}
                                />
                              ) : (
                                <img
                                  src={icon2}
                                  alt="Bitmap-3"
                                  style={{ width: "27.42px" }}
                                />
                              )}
                            </div>
                            <div className="col-12 mt-1">
                              <p
                                style={{
                                  fontWeight: "500",
                                  letterSpacing: "1px",
                                  textAlign: "center",
                                  fontSize: "13px",
                                }}
                              >
                                {body_department.department_name}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                : departmentData.slice(0, 8).map((body_department) => {
                    return (
                      <div
                        className={`${
                          departmentData.length > 2 ? "col-8 " : "col-12"
                        } col-md-6 pt-3 `}
                        style={{ flex: "0 0 auto" }}
                        key={body_department.id}
                      >
                        <div
                          // className="p-3 make-orange"
                          className="p-3"
                          style={{
                            width: "100%",
                            height: "114px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "16px",
                            backgroundColor:
                              filterdoctorsData === body_department.dept_id
                                ? "#f4d69d"
                                : "#E6DFCF",
                            // color:
                            //   filterdoctorsData === body_department.dept_id
                            //     ? "#FFFFFF"
                            //     : "#000000",
                            color: "#000000",
                            cursor: "pointer",
                          }}
                          onClick={() => handlerId(body_department.dept_id)}
                        >
                          <div className="row d-flex align-items-center flex-column justify-content-center">
                            <div className="col-12 d-flex align-items-center justify-content-center">
                              {body_department.image ? (
                                <img
                                  src={
                                    IMAGE_URL +
                                    "DepartmentImage/" +
                                    body_department.image
                                  }
                                  alt="avtars"
                                  style={{ width: "27.42px" }}
                                />
                              ) : (
                                <img
                                  src={icon2}
                                  alt="Bitmap-3"
                                  style={{ width: "27.42px" }}
                                />
                              )}
                            </div>
                            <div className="col-12 mt-1">
                              <p
                                style={{
                                  fontWeight: "500",
                                  letterSpacing: "1px",
                                  textAlign: "center",
                                  fontSize: "13px",
                                }}
                              >
                                {body_department.department_name}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
            </div>
          </div>
          <div className="col-md-6 d-flex flex-column justify-content-between h-100">
            <div
              className={`${isMobile ? "mt-5" : ""}`}
              style={{
                marginBottom: "10px",
              }}
            >
              <h3
                className="text-start w-100"
                style={{
                  color: "#af9763",
                  fontSize: "28px",
                  fontWeight: "500",
                }}
              >
                Doctors
              </h3>
            </div>
            <div
              className="row justify-content-start departmentsContainer"
              style={{
                overflowY: "auto", // Vertical scroll remains
                overflowX: "auto", // Enable horizontal scroll
              }}
            >
              {doctorsDetails.length > 0
                ? doctorsDetails.map((body_department) => {
                    return (
                      <div
                        className={`${
                          doctorsDetails.length > 2 ? "col-10" : "col-12"
                        } col-md-12 pt-3`}
                        key={body_department.id}
                      >
                        <div
                          className="card"
                          style={{
                            backgroundColor: "#E6DFCF",
                            borderRadius: "16px",
                            // height: "157px",
                          }}
                        >
                          <div className="card-body d-flex ">
                            {body_department.doctor_profile ? (
                              <img
                                src={
                                  IMAGE_URL +
                                  "DoctorProfileImg/" +
                                  body_department.doctor_profile
                                }
                                alt="doctor profile"
                                style={{
                                  width: "70px",
                                  borderRadius: "100px",
                                  height: "70px",
                                  objectFit: "cover",
                                  objectPosition: "top",
                                }}
                              />
                            ) : (
                              <img
                                src={icon2}
                                alt="Bitmap-3"
                                style={{
                                  width: "27.42px",
                                  objectFit: "cover",
                                  objectPosition: "top",
                                }}
                              />
                            )}
                            <div className="px-2">
                              <Link
                                className="text-decoration-none"
                                to={`/consultant/${body_department.slug}`}
                              >
                                <h3
                                  className="doctorName"
                                  title={body_department.doctor_name}
                                  style={{
                                    fontSize: "22px",
                                    textTransform: "capitalize",
                                    textAlign: "left",
                                  }}
                                >
                                  {body_department.doctor_name.slice(0, 17)}...
                                </h3>
                              </Link>
                              <h3
                                className="doctordpts"
                                style={{
                                  fontSize: "14px",
                                  textTransform: "capitalize",
                                  textAlign: "left",
                                }}
                              >
                                {body_department.department_mave
                                  ? body_department.department_mave
                                      .department_name
                                  : body_department.department_name}
                              </h3>
                              <p
                                className="doctordscr"
                                style={{
                                  fontWeight: "400",
                                  letterSpacing: "1px",
                                  textAlign: "left",
                                  fontSize: "12px",
                                }}
                              >
                                {body_department.degree
                                  ? body_department.degree.slice(0, 26)
                                  : ""}
                              </p>
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "flex-end",
                              width: "100%",
                              paddingBottom: "10px",
                            }}
                          >
                            <a
                            // className="text-decoration-none "
                            // href="#offcanvasExample"
                            // data-bs-toggle="offcanvas"
                            // role="button"
                            // aria-controls="offcanvasExample"
                            >
                              {localStorage.getItem(USER_LOCAL_ID) ? (
                                <button
                                  type="button"
                                  style={{
                                    fontSize: isMobile ? "12px" : "18px",
                                    padding: "5px 20px",
                                    backgroundColor: "#AF9763",
                                    color: "#fff",
                                    textTransform: "capitalize",
                                    border: "none",
                                    borderRadius: "6px",
                                    fontWeight: "bold",
                                    marginRight: "15px",
                                  }}
                                  onClick={() =>
                                    setSelectedDoctor(body_department)
                                  }
                                  data-bs-toggle="offcanvas"
                                  data-bs-target="#BookAppointMentParticularDoctorPopUp"
                                  aria-controls="BookAppointMentParticularDoctorPopUp"
                                >
                                  Book Now
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  style={{
                                    fontSize: isMobile ? "12px" : "18px",
                                    padding: "5px 20px",
                                    backgroundColor: "#AF9763",
                                    color: "#fff",
                                    textTransform: "capitalize",
                                    border: "none",
                                    borderRadius: "6px",
                                    fontWeight: "bold",
                                    marginRight: "15px",
                                  }}
                                  href="#offcanvasExample"
                                  data-bs-toggle="offcanvas"
                                  role="button"
                                  aria-controls="offcanvasExample"
                                >
                                  Book Now
                                </button>
                              )}
                            </a>
                          </div>
                        </div>
                      </div>
                    );
                  })
                : doctorsData.map((body_department) => {
                    // console.log('your log output',doctorsData)
                    return (
                      <div
                        className={`${
                          doctorsData.length > 2 ? "col-12" : "col-10"
                        }col-md-12 pt-3`}
                        key={body_department.id}
                      >
                        <div
                          className="card "
                          style={{
                            backgroundColor: "#E6DFCF",
                            borderRadius: "16px",
                            // height: "157px",
                          }}
                        >
                          <div className="card-body d-flex ">
                            {body_department.doctor_profile ? (
                              <img
                                src={
                                  IMAGE_URL +
                                  "DoctorProfileImg/" +
                                  body_department.doctor_profile
                                }
                                alt="doctor profile"
                                style={{
                                  width: "70px",
                                  borderRadius: "100px",
                                  height: "70px",
                                  objectFit: "cover",
                                  objectPosition: "top",
                                }}
                              />
                            ) : (
                              <img
                                src={icon2}
                                alt="Bitmap-3"
                                style={{
                                  width: "27.42px",
                                  objectFit: "cover",
                                  objectPosition: "top",
                                }}
                              />
                            )}
                            <div className="px-2">
                              <h3
                                className="doctors doctorName"
                                title={body_department.doctor_name}
                                style={{
                                  fontSize: "22px",
                                  textTransform: "capitalize",
                                  textAlign: "left",
                                }}
                              >
                                {body_department.doctor_name.slice(0, 17)}...
                              </h3>
                              <h3
                                className="doctordpts"
                                style={{
                                  fontSize: "14px",
                                  textTransform: "capitalize",
                                  textAlign: "left",
                                }}
                              >
                                {body_department.department_name}
                              </h3>
                              <p
                                className="doctordscr"
                                style={{
                                  fontWeight: "400",
                                  letterSpacing: "1px",
                                  textAlign: "left",
                                  fontSize: "12px",
                                }}
                              >
                                {body_department.degree
                                  ? body_department.degree.slice(0, 26)
                                  : ""}
                              </p>
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "flex-end",
                              width: "97%",
                              paddingBottom: "10px",
                            }}
                          >
                            <a>
                              {localStorage.getItem(USER_LOCAL_ID) ? (
                                <button
                                  type="button"
                                  style={{
                                    fontSize: isMobile ? "12px" : "18px",
                                    // width: "100px",
                                    height: "40px",
                                    backgroundColor: "#AF9763",
                                    color: "#fff",
                                    textTransform: "capitalize",
                                    border: "none",
                                    borderRadius: "6px",
                                    fontWeight: "bold",
                                    padding: "5px 20px",
                                    marginRight: "15px",
                                  }}
                                  onClick={() =>
                                    setSelectedDoctor(body_department)
                                  }
                                  data-bs-toggle="offcanvas"
                                  data-bs-target="#BookAppointMentParticularDoctorPopUp"
                                  aria-controls="BookAppointMentParticularDoctorPopUp"
                                >
                                  Book Now
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  style={{
                                    fontSize: isMobile ? "12px" : "18px",
                                    // width: "100px",
                                    height: "40px",
                                    backgroundColor: "#AF9763",
                                    color: "#fff",
                                    textTransform: "capitalize",
                                    border: "none",
                                    borderRadius: "6px",
                                    fontWeight: "bold",
                                    padding: "5px 20px",
                                    marginRight: "15px",
                                  }}
                                  href="#offcanvasExample"
                                  data-bs-toggle="offcanvas"
                                  role="button"
                                  aria-controls="offcanvasExample"
                                >
                                  Book Now
                                </button>
                              )}
                            </a>
                          </div>
                        </div>
                      </div>
                    );
                  })}
            </div>
          </div>
        </div>
      </div>

      <BookAppointmentParticularDoctorPopUp
        doctorData={selectedDoctor}
        setSelectedDoctor={setSelectedDoctor}
      ></BookAppointmentParticularDoctorPopUp>
    </div>
  );
};

export default Department;



// WEBPACK FOOTER //
// ./src/component/frontend/commonsections/Department.js